import { CookieHeaderKeyMap } from '../../constants/cookie';
import { burnContextCookies } from './burnContextCookies';

import type { GetServerSidePropsContext } from 'next';

/**
 * Set-Cookie 헤더에 쿠키 배열을 추가합니다.
 * @description
 * - 기존 헤더 값을 보존한 뒤 새로운 쿠키를 덧붙입니다.
 * @example
 * // appendContextCookies(context, ['KC_AUT=token'])
 */
export const appendContextCookies = (
  context: Pick<GetServerSidePropsContext, 'res'>,
  cookies: string[],
) => {
  const currentHeader = context.res.getHeader(CookieHeaderKeyMap.SET_COOKIE);
  const preservedCookies = Array.isArray(currentHeader)
    ? currentHeader
    : typeof currentHeader === 'string'
      ? [currentHeader]
      : [];

  burnContextCookies(context, [...preservedCookies, ...cookies]);
};
